import { createSelector } from 'reselect';

const selectCache = (state: any) => state.session;

export const selectIsAuthenticated = createSelector(
  selectCache,
  (cache: any) => cache.isAuthenticated
);

export const currentUser = createSelector(
  selectCache,
  (cache: any) => cache.currentUser
);

export const userTimezone = createSelector(
  selectCache,
  (cache: any) => cache.currentUser.preferences?.timezone || 'Australia/Sydney'
);

export const selectUserId = createSelector(
  selectCache,
  (cache: any) => cache.currentUser.id
);

export const selectSessionExipyIn = createSelector(
  selectCache,
  (cache: any) => cache.sessionExpiryIn
);

export const selectScreenSize = createSelector(
  selectCache,
  (cache: any) => cache.screenSize
);

export const selectIsFromSwxLocate = createSelector(
  selectCache,
  (cache: any) => cache.isFromSwxLocate
);

export const selectRedirectPath = createSelector(
  selectCache,
  (cache: any) => cache.redirectPath
);

export const selectBasemapSession = createSelector(
  selectCache,
  (cache: any) => cache.basemapSession
);

export const selectPurchasedAuthorisation = createSelector(
  selectCache,
  (cache: any) => cache.purchasedAuthorisation
);
